<template>
  <v-row class="align-center mb-3" id="titleAndSearch">
    <v-col md="auto">
      <div class="d-flex align-center my-1">
        <SvgIcon
          class="secondary--text mr-3"
          :width="30"
          :height="30"
          :iconType="icon"
        />
        <div class="titleAndSearch__title secondary--text font-weight-bold">
          {{ title }}
        </div>
      </div>
    </v-col>
    <v-col
      :md="searchSize"
      class="d-flex align-center"
      :offset-md="isAgentsList ? 4 : 0"
      v-if="showSearch"
    >
      <v-text-field
        :id="idInputSearch"
        hide-details
        :label="
          $t('fleet_management.entities.items_header.labels.label_search_input')
        "
        v-model="searchTermInput"
        @keyup="search"
        @keyup.enter="executeSearch"
        class="pt-0 mt-0"
      >
        <template v-slot:append class="mt-0" v-if="!isAgentsList">
          <div>
            <span v-if="totalMatches > 0"
              >{{ matchPosition }}/{{ totalMatches }}</span
            >
            <span v-else-if="searchTerm.length > 0 && totalMatches == 0"
              >0/0</span
            >
            <v-btn
              :disabled="totalMatches > 0 ? false : true"
              icon
              @click="decrease"
            >
              <v-icon>mdi-chevron-up</v-icon>
            </v-btn>
            <v-btn
              :disabled="totalMatches > 0 ? false : true"
              icon
              @click="increase"
            >
              <v-icon>mdi-chevron-down</v-icon>
            </v-btn>
          </div>
        </template>
      </v-text-field>
      <v-btn
        v-if="showSearchButton"
        :disabled="loading"
        :loading="loading"
        class="tertiary white--text ml-2"
        rounded
        text
        @click="executeSearch"
      >
        {{ 
          $t(
            'fleet_management.entities.items_header.labels.button_search_input'
          )
        }}
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { SvgIcon, firebaseServices } from '@leapsight/styleguide'
import { FirebaseTagNames } from '@leapsight/portal'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'ItemsHeader',
  props: {
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    showSearch: {
      type: Boolean,
      required: true
    },
    searchSize: {
      type: Number,
      //Tamaño default que ocupara la columna que contiene el input search
      default: 4
    },
    loading: {
      type: Boolean,
      default: false
    },
    searchTermInputReset: {
      type: Boolean,
      default: false
    },
    idInputSearch: {
      type: String
    }
  },
  components: {
    SvgIcon
  },
  data() {
    return {
      searchTerm: '',
      matchPosition: 1,
      totalMatches: 0
    }
  },
  methods: {
    ...mapActions(['setSearch', 'setMatchPosition']),
    search() {
      if (
        this.$route.name !== 'AgentsList' ||
        this.searchTermInput.length < 1
      ) {
        this.resetPosition()
        this.setSearch(this.searchTerm)
      }
    },
    resetSearch() {
      this.searchTermInput = ''
      this.resetPosition()
      this.setSearch('')
    },
    matchCounter(value) {
      this.totalMatches = value.length
    },
    increase() {
      if (this.matchPosition == this.totalMatches) {
        this.matchPosition = 1
      } else {
        this.matchPosition++
      }
    },
    decrease() {
      if (this.matchPosition == 1) {
        this.matchPosition = this.totalMatches
      } else {
        this.matchPosition--
      }
    },
    resetPosition() {
      this.matchPosition = 1
    },
    executeSearch() {
      if (this.$route.name === 'persons') {
        firebaseServices.logEvent(
          firebaseServices.analytics,
          FirebaseTagNames.INP_FLEET_MANAGEMENT_PERSONS_SEARCH
        )
      } else {
        firebaseServices.logEvent(
          firebaseServices.analytics,
          FirebaseTagNames.INP_FLEET_MANAGEMENT_AGENTS_SEARCH
        )
      }

      if (!this.loading) {
        this.resetPosition()
        this.setSearch(this.searchTerm)
        this.$store.dispatch('events/filterAgentsByString', {
          string: this.searchTermInput
        })
      }
    }
  },
  mounted() {
    this.searchTermInputReset = true
  },
  computed: {
    ...mapGetters(['getSearchMatch']),
    searchTermInput: {
      get() {
        return this.searchTerm
      },
      set(value) {
        this.searchTerm = value.toLowerCase()
      }
    },
    isAgentsList() {
      return this.$route.name === 'AgentsList'
    },
    showSearchButton() {
      return this.isAgentsList && this.searchTermInput.length > 0
    }
  },
  watch: {
    getSearchMatch() {
      const matches = this.getSearchMatch
      this.matchCounter(matches)
    },
    matchPosition() {
      this.setMatchPosition(this.matchPosition)
    },
    searchTerm(string) {
      const routeActions = {
        EntitiesList: 'things/filterThingsByString',
        PersonsList: 'persons/filterPersonsByString',
        'GeofencesList': 'filterGeofencesByString',
        TagsList: 'tags/filterTagsByString',
        PersonGroupsList: 'tags/filterPersonGroupsByString',
        PointsList: 'filterPointsByString'
      }

      const action = routeActions[this.$route.name]
      if (action) {
        this.$store.dispatch(action, { string })
      }

      if (this.isAgentsList && this.searchTermInput.length < 1) {
        this.$store.dispatch('events/filterAgentsByString', { string })
      }
    },
    searchTermInputReset(newValue) {
      if (newValue) {
        this.searchTermInput = ''
        this.setSearch(this.searchTerm)
      }
    },
    $route(to, from) {
      if (to.name === 'PointsList') {
        this.resetSearch()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#titleAndSearch {
  .titleAndSearch__title {
    font-size: 1.375rem;
  }

  @media (max-width: 960px) {
    .v-col {
      flex-direction: column;
      align-items: flex-start;
    }
    .v-text-field {
      width: 100%;
    }
    .v-btn {
      margin-top: 10px;
    }
  }
}
</style>
